import fetch from '@/utils/fetch';
import trendFetch from '@/utils/trendFetch';
export function wxlogin(params) {
  return fetch({
    url: '/prod-api/weoauth/oauthInfo',
    method: 'get',
    params,
  });
}
//token
export function getMobileToken(data) {
  return fetch({
    url: '/prod-api/getMobileToken',
    method: 'POST',
    data: data,
  });
}

//获取板块列表
export function getSectionList(params = {}) {
  return fetch({
    url: '/prod-api/yca/section/getSectionList',
    method: 'get',
    params,
  });
}

//添加订阅
export function saveSubscribe(data) {
  return fetch({
    url: '/prod-api/yca/subscribe/saveSubscribe',
    method: 'post',
    data,
  });
}

//获取用户
export function getSubscribeInfo(data) {
  return fetch({
    url: '/prod-api/yca/subscribe/getSubscribeInfo',
    method: 'post',
    data,
  });
}

//删除盯盘
export function rmSubsrcibeInfo(id) {
  return fetch({
    url: `/prod-api/yca/subscribe/${id}`,
    method: 'DELETE',
  });
}

export function updateSubscribeVo(data) {
  return fetch({
    url: '/prod-api/yca/subscribe',
    method: 'PUT',
    data,
  });
}

//板块贴列表
export function plateList(data) {
  return fetch({
    url: '/prod-api/elk/queryPost/scroll',
    method: 'POST',
    data: data,
    // params:data,
  });
}

//我的板块贴列表
export function dumpPostPage(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/dumpPostPage',
    method: 'POST',
    data: data,
    // params:data,
  });
}

//帖子查询

export function plateSearch(data) {
  return fetch({
    url: '/prod-api/yca/post/searchPost',
    method: 'POST',
    data: data,
    params: data,
  });
}

//热搜查询
export function queryTopHotWord(data) {
  return fetch({
    url: '/prod-api/yca/post/queryTopHotWord',
    method: 'GET',
    params: data,
  });
}

//热帖
export function queryHotPosts(data) {
  return fetch({
    url: '/prod-api/yca/post/queryHotPosts',
    method: 'POST',
    data: data,
  });
}
//用户关注的帖子ID
export function getSubPostIds(data) {
  return fetch({
    url: `/prod-api/yca/subTitle/getSubPostIds/${data.openId}`,
    method: 'get',
    params: data,
  });
}

//用户特别关注
export function subscribe(data) {
  return fetch({
    url: `/prod-api/yca/subTitle/subscribe`,
    method: 'POST',
    data: data,
  });
}

//用户取消关注
export function cancelSubscribe(data) {
  return fetch({
    url: `/prod-api/yca/subTitle/cancelSubscribe`,
    method: 'POST',
    data: data,
  });
}

//用户关注的帖子
export function getSubscribePost(data) {
  return fetch({
    url: `/prod-api/yca/post/getSubscribePost`,
    method: 'get',
    params: data,
  });
}

//商品列表
export function getGoods(data) {
  return fetch({
    url: '/prod-api/weixin/api/ma/goodsspu/page',
    method: 'get',
    params: data,
  });
}

//新增订单
export function orderinfo(data) {
  return fetch({
    url: '/prod-api/weixin/api/ma/orderinfo',
    method: 'post',
    data: data,
  });
}

//支付
export function unifiedOrder(data, appId) {
  return fetch({
    url: '/prod-api/weixin/api/ma/orderinfo/unifiedOrder',
    method: 'post',
    headers: {
      'app-id': appId,
    },
    data: data,
  });
}

//wx config
export function wxConfig(data) {
  return fetch({
    url: '/prod-api/weoauth/intiInfo',
    method: 'post',
    params: data,
  });
}

//用户信息
export function wxuser(data = {}) {
  return fetch({
    url: '/prod-api/weixin/api/ma/wxuser',
    method: 'get',
    params: data,
  });
}

//免费领取7天会员
export function getFreeVip(data = {}) {
  return fetch({
    url: '/prod-api/weixin/api/ma/wxuser/getFreeVip',
    method: 'get',
    params: data,
  });
}

//免费领取15天会员
export function getActivityVip(data = {}) {
  return fetch({
    url: '/prod-api/weixin/api/ma/wxuser/getActivityVip',
    method: 'get',
    params: data,
  });
}

//免费领取1天发帖会员
export function getFreeFTVip(data = {}) {
  return fetch({
    url: '/prod-api/weixin/api/ma/wxuser/getFreeFTVip',
    method: 'get',
    params: data,
  });
}

//黑名单列表
export function getBlackList(data = {}) {
  return fetch({
    url: `/prod-api/yca/blackList/getBlackList/${data.openId}`,
    method: 'get',
  });
}

//添加黑名单
export function addMember(data) {
  return fetch({
    url: '/prod-api/yca/blackList/addMember',
    method: 'POST',
    data: data,
  });
}

//移除黑名单
export function delMember(data) {
  return fetch({
    url: '/prod-api/yca/blackList/delMember',
    method: 'POST',
    data: data,
  });
}

//修改黑名单
export function updateMember(data) {
  return fetch({
    url: '/prod-api/yca/blackList/updateMember',
    method: 'PUT',
    data: data,
  });
}

//热门品种查询
export function gethotLexicon(data) {
  return fetch({
    url: '/prod-api/yca/hotLexicon/list',
    method: 'POST',
    data: data,
  });
}

//热门品种价格走势查询
export function getQueryPrice(data) {
  return fetch({
    url: '/prod-api/yca/hotPrice/queryPrice',
    method: 'POST',
    data: data,
  });
}

//盘口数据列表
export function getHotPrice(data) {
  return fetch({
    url: '/prod-api/yca/hotPrice/page',
    method: 'get',
    params: data,
  });
}

//活动个人收益
export function getUserStatIncomeInfo(data) {
  return fetch({
    url: '/prod-api/weixin/api/userIncome/getUserStatIncomeInfo',
    method: 'get',
    params: data,
  });
}

//活动周收益
export function getWeekUserIncomeInfo(data) {
  return fetch({
    url: '/prod-api/weixin/api/userIncome/getWeekUserIncomeInfo',
    method: 'get',
    params: data,
  });
}

//我的收益

export function getUserIncomeInfo(data) {
  return fetch({
    url: '/prod-api/weixin/api/userIncome/getUserIncomeInfo',
    method: 'get',
    params: data,
  });
}

//一尘账号登录
export function yichenLogin(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/login',
    method: 'post',
    data: data,
  });
}

//一尘账号登录
export function yichenLoginEx(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/loginEx',
    method: 'post',
    data: data,
  });
}

//一尘发帖
export function createPost(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/createPost',
    method: 'post',
    data: data,
  });
}

//一尘发帖
export function dumpPost(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/dumpPost',
    method: 'post',
    params: data,
  });
}

//一尘帖子回复
export function replyPost(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/replyPost',
    method: 'post',
    data: data,
  });
}

//查询道具数量
export function queryProps(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/queryProps',
    method: 'post',
    data: data,
  });
}

//使用道具
export function useProps(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/useProps',
    method: 'post',
    data: data,
  });
}

//图片压缩上传

export function uploaderfiles(data) {
  return fetch({
    url: '/prod-api/yca/picture/upload?' + data,
    method: 'post',
    headers: {
      // 'Content-Type': 'multipart/form-data',
    },
  });
}

//帖子评分
export function addRatingScore(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/addRatingScore',
    method: 'post',
    data: data,
  });
}
//我的参与列表
export function userPartake(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/userPartake',
    method: 'post',
    data: data,
  });
}
//评分列表

export function ratingList(data) {
  return fetch({
    url: '/prod-api/yca/yiChen/ratingList',
    method: 'post',
    data: data,
  });
}

// 签名生成函数
function generateSign(dataArray, secretKey) {
  const md5 = require('md5');
  const signMap = {};
  dataArray.forEach((item) => {
    const key = Object.keys(item)[0];
    const value = item[key];
    signMap[key] = value;
  });

  // 加入 secretKey
  signMap['secretKey'] = secretKey;
  // 按键排序并生成排序后的参数字符串
  const sortedParams = Object.keys(signMap)
    .sort()
    .map((key) => key + signMap[key])
    .join('');
  // 使用 md5 生成签名
  return md5(sortedParams);
}

// 生成签名密钥
function secretKey(obj) {
  let arr = [];
  for (let key in obj) {
    if (key != 'filters') {
      let object = {};
      object[key] = obj[key];
      arr.push(object);
    }
  }
  for (let k in obj.filters) {
    let object1 = {};
    object1[k] = obj.filters[k];
    arr.push(object1);
  }
  let skey = '7caf099bb37109666409b4ebd0114454';
  return generateSign(arr, skey);
}

// 通用查询接口（走势数据专用）
export function queryPannel(data) {
  let obj = {
    pageNo: null,
    pageSize: null,
    filters: {},
    timestamp: new Date().getTime(),
  };
  let o = Object.assign(obj, data);
  let sign = secretKey(o);
  o.sign = sign;
  return trendFetch({
    url: '/api/query/data/pannel',
    method: 'POST',
    data: o,
  });
}